import { defineMessage } from '@redbubble/next/intl';
import ex13FImg from '../assets/models/ex13_f.png';
import ex13MImg from '../assets/models/ex13_m.png';
import { PreQuerySizeGuideData } from '../types';
import {
  extendedInternationalConversions,
  howToChooseSizeTshirtInstructions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 13
 * Vintage Wash T-Shirt
 * weathered-wrapper
 * Data source: https://articore.atlassian.net/wiki/spaces/CORE/pages/4748935329/Physical+product+launches+Input+information+required+Vintage+Wash+T-Shirt#Blank-Configuration-(for-use-in-the-PTR-and-Foundry)
 */

export const experience13: PreQuerySizeGuideData = {
  internationalConversions: extendedInternationalConversions,
  fitIndicator: {
    value: 5 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    male: {
      imageUrl: ex13MImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Large. He usually wears a size Large.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 188 cm / 6’2”',
        }),
        defineMessage({
          defaultMessage: 'Waist: 81 cm / 32"',
        }),
      ],
    },
    female: {
      imageUrl: ex13FImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Medium. She usually wears a size Medium.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 175 cm / 5’9”',
        }),
        defineMessage({
          defaultMessage: 'Waist: 81 cm / 32"',
        }),
      ],
    },
  },
};
